import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { ReportBuilder } from '../components/ReportBuilder'
import { reportService } from '../services/reportService'
import { ReportFormatInfo } from '../types/report'
import { useTenantProductType } from '../hooks/useTenantProductType'
import './Reports.css'

export function Reports() {
  const [showBuilder, setShowBuilder] = useState(false)
  const { isPptOnly } = useTenantProductType()

  const { data: formats } = useQuery<ReportFormatInfo[]>({
    queryKey: ['report-formats'],
    queryFn: async () => {
      return await reportService.getFormats()
    },
  })

  return (
    <div className="reports-page">
      <div className="reports-header">
        <h1>Reports</h1>
        {!isPptOnly && (
          <button
            className="btn-primary"
            onClick={() => setShowBuilder(true)}
          >
            Generate New Report
          </button>
        )}
      </div>

      {showBuilder && !isPptOnly ? (
        <div className="report-builder-container">
          <ReportBuilder
            onReportGenerated={() => setShowBuilder(false)}
            onCancel={() => setShowBuilder(false)}
          />
        </div>
      ) : (
        <div className="reports-content">
          <div className="reports-info">
            <h2>Available Report Types</h2>
            <div className="report-types">
              <Link to="/reports/stc-status" className="report-type-card report-type-card-link">
                <h3>STCS/SS Claim Status Report</h3>
                <p>View outstanding and processed Special Type Consultation (STC) and MICS declarations with date filters and CSV export.</p>
              </Link>
              {isPptOnly && (
                <Link to="/reports/ppt-claims-by-patient" className="report-type-card report-type-card-link">
                  <h3>PPT Claims by Patient Report</h3>
                  <p>Group submitted PPT claims by patient key and review each patient&apos;s claim history.</p>
                </Link>
              )}
              {!isPptOnly && (
                <>
                  <div className="report-type-card">
                    <h3>Aggregate Reports</h3>
                    <p>Generate reports across multiple patients with filtering and sorting capabilities.</p>
                    <ul>
                      <li>Filter by demographics (age, gender, date of birth)</li>
                      <li>Filter by clinical data (conditions, medications, allergies)</li>
                      <li>Sort by multiple fields</li>
                      <li>Export in multiple formats</li>
                    </ul>
                  </div>
                  <div className="report-type-card">
                    <h3>Measurement &amp; Analysis Reports</h3>
                    <p>Produce anonymous outcome-focused reports over specified timeframes.</p>
                    <ul>
                      <li>Filter by diagnosis and consultation date range</li>
                      <li>Slice by GP, practice nurse, or staff ID</li>
                      <li>Minimum dataset enforced with optional fields</li>
                      <li>Supports CSV, JSON, and XML exports</li>
                    </ul>
                  </div>
                </>
              )}
            </div>

            <h2>Export Formats</h2>
            <div className="formats-grid">
              {formats?.map((format) => (
                <div key={format.id} className="format-card">
                  <h3>{format.name}</h3>
                  <p>{format.description}</p>
                </div>
              ))}
            </div>

            {!isPptOnly && (
              <div className="reports-actions">
                <button
                  className="btn-primary"
                  onClick={() => setShowBuilder(true)}
                >
                  Generate Report
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
